<template>
  <div class="person-roundel" :class="['color-' + resourceColor]" :title="resourceLabel" v-if="resFunction === 'person'">
      {{ resourceInitials }}
  </div>
  <span class="place" v-else-if="resFunction === 'place'">
    <i class="fas fa-map-marker-alt" v-if="resFunction === 'place'"></i>
    {{ resourceLabel }}
  </span>
  <span v-else>
    {{ resourceLabel }}
  </span>
</template>

<script>
import _ from 'lodash'

export default {
    name: 'ResourceLabel',
    props: {
        id: {
            required: true,
            type: String,
        },
        resFunction: {
            required: false,
            type: String,
        },
    },
    filters: {
        clamp(value, length, trailingText = '...') {
            // console.info(value, length, trailingText)
            if(_.size(value) > length) {
                return `${value.substring(0, length)}${trailingText}`
            }
            return value
        }
    },
    computed: {
        resourceLabel() {
            const label = _.trim(_.join(_.filter(_.map(['system-jmeno', 'system-prijmeni', 'system-name'], pn => {
                return _.get(this.$store.getters.resourceById(this.id), `propertyValues.${pn}.value.value`, undefined)
            }), _.size), ' '))
            if (_.size(label) === 0) {
                return `ID ${this.id}`
            }
            return label
        },
        resourceInitials() {
            return this.resourceLabel.split(" ").map(a => a[0]).join("")
        },
        resourceColor() {
            return _.get(this.$store.getters.resourceById(this.id), `propertyValues.system-color.value.value`, 'default')
        },
    },
}
</script>

<style scoped>
.person-roundel {
    width: 28px;
    height: 28px;
    display: block;
    border: 2px solid #172b4d;
    text-align: center;
    line-height: 24px;
    border-radius: 50%;
    background-color: #dfe1e6;
    font-weight: bold;
    color: #172b4d;
}
.person-roundel:not(:last-child) {
    margin: 0 5px 0 0;
}
.place {
    white-space: nowrap;
}
.place > .fa-map-marker-alt {
    color: #de4229;
    font-size: 130%;
}

.color-andere {
  border-color: #eee;
  color: #eee;
}
.color-danube {
  border-color: #42a5f5;
  color: #42a5f5;
}
.color-blueMarquerite {
  border-color: #6d61c1;
  color: #6d61c1;
}
.color-fuchsiaPink {
  border-color: #ab47bc;
  color: #ab47bc;
}
.color-cranberry {
  border-color: #ec407a;
  color: #ec407a;
}
.color-coralRed {
  border-color: #ef5350;
  color: #ef5350;
}
.color-pictonBlue {
  border-color: #29b6f6;
  color: #29b6f6;
}
.color-scooter {
  border-color: #26c6da;
  color: #26c6da;
}
.color-persianGreen {
  border-color: #159f92;
  color: #159f92;
}
.color-fern {
  border-color: #66bb6a;
  color: #66bb6a;
}
.color-atlantis {
  border-color: #9ccc64;
  color: #9ccc64;
}
.color-candyCorn {
  border-color: #ffee58;
  color: #ffee58;
}
.color-sunglow {
  border-color: #fdcb2e;
  color: #fdcb2e;
}
.color-webOrange {
  border-color: #fca826;
  color: #fca826;
}
.color-burningOrange {
  border-color: #ff7043;
  color: #ff7043;
}
</style>

